import {Injectable} from '@angular/core';
import {BaseFacade} from '../../../core/abstracts/base-facade.abstract';
import {GeocodingService} from '../service/geocoding.service';
import {GeocodingResponseMapper} from '../mapper/geocoding-response.mapper';
import {BehaviorSubject, distinctUntilChanged, Subject} from 'rxjs';
import {Geocoding} from '../model/geocoding.model';

@Injectable({providedIn: 'root'})
export class LocationFacade extends BaseFacade {

  private readonly geocodingLocationSubject: BehaviorSubject<Geocoding | null> = new BehaviorSubject<Geocoding | null>(null);
  readonly geocodingLocation$ = this.geocodingLocationSubject.asObservable().pipe(
    distinctUntilChanged((prev, curr) => {
      if (prev === null || curr === null) return prev === curr;
      return prev.lat === curr.lat && prev.lng === curr.lng;
    })
  );

  private readonly errorSubject = new Subject<Error | null>();
  readonly error$ = this.errorSubject.asObservable();

  constructor(
    private readonly geocodingService: GeocodingService,
    private readonly geocodingResponseMapper: GeocodingResponseMapper) {
    super();
  }

  public getGeocodedLocation(address: string): void {
    const formattedAddress = address.replace(/^\s*(ul\.?|ulica)\s*/i, '');
    this.geocodingService.getOne({
      q: formattedAddress,
      format: 'json',
      limit: 1
    }).subscribe({
      next: (geocodingResponse) => {
        this.geocodingLocationSubject.next(this.geocodingResponseMapper.map(geocodingResponse));
      },
      error: (error) => {
        this.errorSubject.next(error);
        this.stopLoading();
      }
    });
  }
}
